// Extract track ID from Spotify URL
const extractTrackId = (spotifyLink: string): string => {
  // Handle both formats: full URL or just ID
  const parts = spotifyLink.split('/');
  return parts[parts.length - 1];
};

// Latest track data from MusicSection
export const latestTrackData = {
  title: "Resilient Mind",
  description: "Stream the newest track",
  spotifyLink: "https://open.spotify.com/track/1miiIGFNTedZ0HjLBtOisy",
  youtubeLink: "https://www.youtube.com/channel/UCeYaEjzXGfBKx1uy7-r00jA",
  trackId: "1miiIGFNTedZ0HjLBtOisy" // Extract from the spotifyLink
};

// Function to dynamically get the latest track data from MusicSection
export const getLatestTrackData = () => {
  // This would normally fetch from MusicSection, but for now we'll return the static data
  return latestTrackData;
}; 